var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoEditar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Editar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-116.000000, -538.000000)",
    stroke: "#31383E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Editar",
    transform: "translate(117.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "1.44502703 12.906973 -0.000108108108 19.8131892 6.90610811 18.3680541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8284865,1.98467568 L4.98091892,14.8322432",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92297297,18.3849459 L4.98081081,14.8322432 L1.44513514,12.9071081 L13.7494595,0.569 C14.5081081,-0.189648649 15.7381081,-0.189648649 16.4967568,0.569 L19.2440541,3.3162973 C20.0027027,4.07494595 20.0027027,5.30521622 19.2440541,6.06386486 L6.92297297,18.3849459 Z",
    id: "Stroke-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEditar);
export default __webpack_public_path__ + "static/media/PictoEditar.34b80d8b408538a341692563f3ff2d95.svg";
export { ForwardRef as ReactComponent };